export const NIC_CLIENTE_NOME = {
  nic_sp: 'NIC SÃO PAULO',
  nic_go: 'NIC GOIÂNIA',
};

export function mapUsersToClientesOptions(users = []) {
  return users.map((d) => ({
    value: d._id,
    cpf: d.criancas?.cpf,
    label: d.criancas?.nome,
  }));
}

export function findClienteByNicResponsavel(clientes, responsavelTipo) {
  const targetNome = NIC_CLIENTE_NOME[responsavelTipo];
  if (!targetNome) return null;

  const normalizedTarget = targetNome.toLocaleUpperCase('pt-BR');
  return clientes.find(
    (c) => (c.label || '').toLocaleUpperCase('pt-BR') === normalizedTarget,
  ) || null;
}

export function applyNicClienteAutoFill({
  responsavelTipo,
  clientes,
  setValue,
  setError,
  clearErrors,
  notificationRef,
}) {
  if (responsavelTipo !== 'nic_sp' && responsavelTipo !== 'nic_go') {
    return;
  }

  const cliente = findClienteByNicResponsavel(clientes, responsavelTipo);

  if (cliente) {
    setValue('cliente', cliente);
    if (clearErrors) {
      clearErrors('cliente');
    }
    return;
  }

  setValue('cliente', '');
  if (setError) {
    setError('cliente', {
      type: 'manual',
      message: 'Não foi encontrado cliente para o responsável escolhido',
    });
  }
  if (notificationRef?.current) {
    notificationRef.current.notify({
      message: 'Não foi encontrado cliente para o responsável escolhido',
      color: 'warning',
    });
  }
}
